import { useTranslation } from 'react-i18next'

import { FormikWysiwygField } from '../../../../Formik'
import { TASK_FORM_DESCRIPTION_FIELD_NAME } from '../../TaskForm.constants'

import * as styles from './DescriptionField.module.css'

function DescriptionField({ isEmptyServiceRequest, ...restProps }) {
  const { t } = useTranslation()

  return (
    <FormikWysiwygField
      {...restProps}
      disabled={isEmptyServiceRequest}
      fieldComponentProps={{
        className: styles.descriptionField,
        label: `${t('Task.FormDescriptionFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={TASK_FORM_DESCRIPTION_FIELD_NAME}
      placeholder={t('Task.FormDescriptionFieldPlaceholderKey')}
    />
  )
}

export default DescriptionField
